import api, { setTokens, clearTokens } from './api';
import type { ILoginRequest, ILoginResponse, IUser, IApiResponse } from '@/types';

export const authService = {
  async login(credentials: ILoginRequest): Promise<ILoginResponse> {
    const { data } = await api.post<IApiResponse<ILoginResponse>>(
      '/auth/login',
      credentials
    );
    if (data.data) {
      setTokens(data.data.tokens.accessToken, data.data.tokens.refreshToken);
    }
    return data.data!;
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } finally {
      clearTokens();
    }
  },

  async refreshToken(refreshToken: string): Promise<ILoginResponse> {
    const { data } = await api.post<IApiResponse<ILoginResponse>>(
      '/auth/refresh',
      { refreshToken }
    );
    if (data.data) {
      setTokens(data.data.tokens.accessToken, data.data.tokens.refreshToken);
    }
    return data.data!;
  },

  async me(): Promise<IUser> {
    const { data } = await api.get<IApiResponse<IUser>>('/auth/me');
    return data.data!;
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password', { currentPassword, newPassword });
  },
};
